import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROSPECT_ACTIVE_OPPORTUNITY_STATUSES,
  ADMIN_PROSPECT_FOLLOW_UP_BUCKETS,
  ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE,
  ADMIN_PROSPECT_PUBLIC_RESPONSE_PROCESSING_LIST_STATES,
  ADMIN_PROSPECT_PUBLIC_RESPONSE_PROCESSING_STATES,
  buildListAdminProspectActiveOpportunitiesRequest,
  buildListAdminProspectFollowUpsRequest,
  buildListAdminProspectResponsesToProcessRequest,
  buildSetAdminProspectPublicResponseProcessingRequest,
} from './prospectFollowUpWorkspaceRequest.js';
import {
  parseListAdminProspectActiveOpportunities,
  parseListAdminProspectFollowUps,
  parseListAdminProspectResponsesToProcess,
  parseSetAdminProspectPublicResponseProcessing,
} from './prospectFollowUpWorkspaceResponse.js';

export {
  ADMIN_PROSPECT_ACTIVE_OPPORTUNITY_STATUSES,
  ADMIN_PROSPECT_FOLLOW_UP_BUCKETS,
  ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE,
  ADMIN_PROSPECT_PUBLIC_RESPONSE_PROCESSING_LIST_STATES,
  ADMIN_PROSPECT_PUBLIC_RESPONSE_PROCESSING_STATES,
  buildListAdminProspectActiveOpportunitiesRequest,
  buildListAdminProspectFollowUpsRequest,
  buildListAdminProspectResponsesToProcessRequest,
  buildSetAdminProspectPublicResponseProcessingRequest,
};

export async function listAdminProspectResponsesToProcess(input) {
  const request = buildListAdminProspectResponsesToProcessRequest(input);
  const callable = httpsCallable(functions, 'listAdminProspectResponsesToProcess');
  const result = await callable(request);
  return parseListAdminProspectResponsesToProcess(result?.data);
}

export async function setAdminProspectPublicResponseProcessing(input) {
  const request = buildSetAdminProspectPublicResponseProcessingRequest(input);
  const callable = httpsCallable(functions, 'setAdminProspectPublicResponseProcessing');
  const result = await callable(request);
  return parseSetAdminProspectPublicResponseProcessing(result?.data);
}

export async function listAdminProspectFollowUps(input) {
  const request = buildListAdminProspectFollowUpsRequest(input);
  const callable = httpsCallable(functions, 'listAdminProspectFollowUps');
  const result = await callable(request);
  return parseListAdminProspectFollowUps(result?.data);
}

export async function listAdminProspectActiveOpportunities(input) {
  const request = buildListAdminProspectActiveOpportunitiesRequest(input);
  const callable = httpsCallable(functions, 'listAdminProspectActiveOpportunities');
  const result = await callable(request);
  return parseListAdminProspectActiveOpportunities(result?.data);
}
